import React from "react";
import {
  Box,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { CircleDollarSign, CarTaxiFront } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import CommissionManager from "./CommissionManager";
import { addCommissionAction, fetchCommissionsAction } from "state/actions/driverCommissionsActions";
import AddCommissionForm from "./components/AddCommissionForm";
import ViewCommissions from "./components/ViewCommissions";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

// Main Commission Management Component
const CommissionManagement = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>
      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={CarTaxiFront} label="Driver Commissions" />
          <CustomTab icon={CircleDollarSign} label="Paygate Commissions" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <CommissionManager
              commissionType="Driver"
              fetchCommissionsAction={fetchCommissionsAction}
              addCommissionAction={addCommissionAction}
              selectorKey="driverCommissions"
              AddCommissionForm={AddCommissionForm}
              ViewCommissions={ViewCommissions}
              icon={<CarTaxiFront size={16} />}
            />
          </TabPanel>

          <TabPanel>
            <CommissionManager
              commissionType="Paygate"
              fetchCommissionsAction={fetchCommissionsAction} 
              addCommissionAction={addCommissionAction}    
              selectorKey="paygateCommissions"
              AddCommissionForm={AddCommissionForm}        
              ViewCommissions={ViewCommissions}            
              icon={<CircleDollarSign size={16} />}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default CommissionManagement;
